import React from "react"
import { SystemAccessTokens } from "./system_access_tokens"
import { sitka } from "../../redux/store"
import { getSystemAccessTokens } from "../../util/oauth_utils"
import { ConnectedAppsList } from "./connected_apps_list"
import { Spinner } from "@blueprintjs/core"
import styled from "styled-components"

export const ConnectedApps = ({
    oAuthTokens,
    teams,
    profile,
    googleCalendarConfigs,
    zoomConfigs,
    tags,
}) => {
    const { oauth } = sitka.getModules()
    const { saveInProgress } = googleCalendarConfigs
    const accessTokens = getSystemAccessTokens(oAuthTokens)
    return (
        <Wrapper>
            {saveInProgress && <Spinner />}
            <ConnectedAppsList
                configs={googleCalendarConfigs}
                zoomConfigs={zoomConfigs}
                tags={tags}
                teams={teams}
                profile={profile}
            />
            <SystemAccessTokens
                tokens={accessTokens}
                handleRevokeOAuthToken={oauth.handleRevokeOAuthToken}
            />
        </Wrapper>
    )
}

const Wrapper = styled.div`
    .pt-spinner {
        position: absolute;
        right: calc(50vw - 25px);
        top: calc(50vh - 25px);
    }
`


// WEBPACK FOOTER //
// ./src/components/connected_apps/connected_apps.jsx